import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from 'redux-state/store';

interface PublicRoutesProps {
  children: React.ReactNode;
}

const PublicRoutes = ({ children }: PublicRoutesProps) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PublicRoutes;
